// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"fa3665d6","833":"6545502d"}[chunkId] + ".chunk.js";
};